import { Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { ReportService } from '../../service/report.service';
// import { GridApi } from 'ag-grid-community';
import { ColDef, ColGroupDef, GridApi, NavigateToNextCellParams,CellPosition } from 'ag-grid-community';

@Component({
  selector: 'app-table-extraction-grid',
  templateUrl: './table-extraction-grid.component.html',
  styleUrls: ['./table-extraction-grid.component.scss']
})
export class TableExtractionGridComponent implements OnInit, OnDestroy {
  @Input() sideCutKey_UUID:string = "";
  @Input() tabData:any = {};
  @Output() onGridLoaded = new EventEmitter();
  private gridApi!: GridApi;
  public tab:any = {}
  public gridActivated:boolean = true;
  constructor(public reportService:ReportService,
    private readonly renderer: Renderer2) { 
      this.gridActivated = true;
      this.reportService.emitSigCellCoordinates.subscribe((coordinates)=>{
        this.removeStars(coordinates);
      });
    }

  ngOnDestroy(): void {
    this.gridApi = null;
    this.gridActivated = false;
  }
  @HostListener('window:resize')
    onResize() {
      if (!this.gridApi) return;
      setTimeout(() => {
        this.gridApi.sizeColumnsToFit();
      });
  }
  ngOnInit(): void {
    this.tab = this.tabData
    this.parseTabData();
  }

  parseTabData(){
    if (!(this.tab.data && this.tab.data.length > 0)) {
      this.reportService.parseSidecutToGridJson(this.sideCutKey_UUID,true);
    }
  }

  onGridReady(params): void {
    // if(!this.gridApi) {
    //     this.gridApi = params.api;
    // }
    this.gridApi = params.api;
    // console.log("ready in grid ===>>> ",Date.now())
    this.onGridLoaded.emit();
    // this.gridColumnApi = params.columnApi;
  }
  sizeToFit(): void {
    if (this.gridApi) {
    }
    this.gridApi.sizeColumnsToFit();
  }
  onModelUpdated(params): void {
    if(!this.gridApi) {
        this.gridApi = params.api;
    }
    this.sizeToFit();
  }

  onFirstDataRendered(): void {
    if (this.gridApi) {
    }
    this.gridApi.sizeColumnsToFit();
  }

  removeStars(coordinates){
    let currentGrid = <HTMLDivElement>  document.getElementsByClassName(this.reportService.slugGenerator(coordinates.cutUUID))[0];
    let activeEle = document.getElementsByClassName('ag-cell-focus-sig');
    this.sizeToFit();
    if (activeEle.length) {
          for (let i = 0; i < activeEle.length; i++) {
            const element =<HTMLDivElement> activeEle[i];
           
            if (activeEle.length -1 == i && coordinates.cutUUID == this.sideCutKey_UUID) {
              this.focusCell(coordinates,currentGrid); 
            }
            let starElement = element.getElementsByClassName('star-img');
            for (let j = 0; j < starElement.length; j++) {
              this.renderer.removeChild(element,starElement[j]);
            }
            // this.renderer.removeChild(element,element.getElementsByClassName('star-img')[0],true);
            element.classList.remove('ag-cell-focus-sig');
            // if (activeEle.length == 0 && coordinates.cutUUID == this.sideCutKey_UUID) {
            //   this.focusCell(coordinates,currentGrid); 
            // }

          }
        }else{
          if (coordinates.cutUUID == this.sideCutKey_UUID) {
            this.focusCell(coordinates,currentGrid); 
          }
        }
  }

  focusCell(coordinates,currentGrid){
      if (this.gridApi) {
        this.gridApi.ensureIndexVisible(coordinates.r,'middle');      
        this.gridApi.ensureColumnVisible(coordinates.parentPath,'start');
      }
      // if (this.gridApiObj[this.sideCutKey_UUID]) {
      //   this.gridApiObj[this.sideCutKey_UUID].ensureIndexVisible(coordinates.r,'middle');      
      //   this.gridApiObj[this.sideCutKey_UUID].ensureColumnVisible(coordinates.parentPath,'start');
      // }

      const star = this.renderer.createElement('img');
      this.renderer.setAttribute(star,"src","../../../assets/repository/icons/path@2x.png");
      this.renderer.addClass(star, 'star-img');
      if (this.reportService.sigComparetype == "AmongColumn") {
        this.renderer.addClass(star, 'Golden-Star-among');
      }else{
        this.renderer.addClass(star, 'Golden-Star');
      }
      setTimeout(() => {
        let row =<HTMLDivElement> currentGrid.querySelectorAll('[row-index="'+coordinates.r+'"]')[1];
        if (row) {
          let cell = <HTMLDivElement>  row.querySelector('[aria-colindex="'+coordinates.c+'"]');
          cell.classList.add('ag-cell-focus-sig');
          this.renderer.appendChild(cell,star)
          cell.focus();

          setTimeout(() => {
            if (this.gridApi) {
              this.gridApi.ensureColumnVisible(coordinates.parentPath,'start');
            }
            // if (this.gridApiObj[this.sideCutKey_UUID]) {
            //   this.gridApiObj[this.sideCutKey_UUID].ensureColumnVisible(coordinates.parentPath,'start');
            // }
          }, 200);
        }
      }, 200);
}

}
